import {getEnv} from '@/config/environment';

export interface SharedListUrlOptions {
  refId: string;
  type: 'labels' | 'creator_groups' | 'contracts' | 'proposals';
  includePosts: boolean;
  includeNetworkAnalytics: boolean;
  includePortfolio: boolean;
}

/**
 * Generates a shareable URL for a creator list, creator group, contract, or proposal
 * @param options - Configuration for the shared list URL
 * @returns The complete shareable URL as a string
 */
export function generateSharedListUrl(options: SharedListUrlOptions): string {
  const {refId, type, includePosts, includeNetworkAnalytics, includePortfolio} =
    options;

  const url = new URL(`${getEnv().VITE_DOMAIN_HOST}/shared-list`);
  url.searchParams.append('ref_id', refId);
  url.searchParams.append('type', type);
  url.searchParams.append('posts', includePosts.toString());
  url.searchParams.append(
    'networkAnalytics',
    includeNetworkAnalytics.toString()
  );
  url.searchParams.append('portfolio', includePortfolio.toString());

  return url.href;
}
